import React, { useState } from 'react';
import { Menu, Modal } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import Login from '../Pages/Auth/Login';
import {

    AuditOutlined,
    ContactsOutlined,
    CopyFilled,
    FileOutlined,
    HomeOutlined,
    MedicineBoxOutlined,
    TeamOutlined,


} from '@ant-design/icons';

const rootSubmenuKeys = ['dashboard', 'structure', 'params', 'docs', 'process', 'compta'];

const baseItems = [
    {
        label: 'Tableau de Bord',
        key: 'dashboard',
        icon: <HomeOutlined />
    },
    {
        label: 'Ma situation',
        key: 'situation',
        icon: <AuditOutlined />
    },
    {
        label: 'Mes Documents',
        key: 'documents',
        icon: <CopyFilled />
    },
    {
        label: 'Ma famile',
        key: 'famille',
        icon: <TeamOutlined />
    },
    {
        label: 'Fournisseurs de soins',
        key: 'fournisseurs_soins',
        icon: <MedicineBoxOutlined />
    },
    {
        label: 'Contact',
        key: 'contact',
        icon: <ContactsOutlined />
    },
    {
        label: 'Textes et Réglements',
        key: 'textes_reglement',
        icon: <FileOutlined />
    },
    /* {
        label: "Déconnexion",
        icon: <PoweroffOutlined />,
        key: "signout"
    } */

];

export default function SideMenu() {
    const navigate = useNavigate();
    const location = useLocation();
    const [openKeys, setOpenKeys] = useState(['dashboard']);

    const userProfil = localStorage.getItem("profil");

    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    const logoBlue = '#114b88';

    const modernItems = baseItems.map((item) => {
        const originalIcon = item.icon;
        const iconNode = originalIcon
            ? React.cloneElement(originalIcon, { className: 'menu-entry-icon', style: { color: logoBlue, fontSize: 16 } })
            : null;
        const labelNode = (
            <div className="menu-entry" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <span className="menu-entry-badge">{iconNode}</span>
                <span className="menu-entry-label" style={{ fontWeight: 600 }}>{item.label}</span>
            </div>
        );
        return {
            ...item,
            icon: null,
            label: labelNode,
            style: { borderRadius: 8, margin: '2px 8px' }
        };
    });

    const filteredItems = modernItems.map(item => {


        // Si aucun filtre n'est nécessaire, renvoyer l'élément tel quel
        return item;
    }).filter(item => item !== null); // Filtrer les éléments nuls (comme ceux qui ne sont pas 'docs' pour 'role_4')


    // Déterminer la clé sélectionnée à partir de l'URL
    const pathname = location.pathname || '/dashboard';
    const pathKey = (pathname.replace(/^\//, '').split('/')[0] || 'dashboard');

    return (
        <div>
            <Menu
                className="custom-side-menu"
                onClick={({ key }) => {
                    if (key === "signout") {
                        Modal.confirm({
                            title: "Déconnexion",
                            content: "Voulez-vous vraiment quitter l'application?",
                            okText: "Oui",
                            okType: 'danger',
                            cancelText: 'Annuler',
                            centered: true,
                            onOk: () => {
                                localStorage.removeItem("auth");
                                localStorage.removeItem("user_connect");
                                localStorage.removeItem("notif_toast_shown");
                                localStorage.removeItem("notifs_lues");
                                localStorage.removeItem("portable");
                                localStorage.removeItem("pwd_portail");
                                localStorage.removeItem("prenom");
                                localStorage.removeItem("nom");
                                localStorage.removeItem("numcont");

                                navigate("/login");
                                window.location.reload(true);
                                return (<Login />);
                            }
                        });
                    } else {
                        navigate(key);
                    }
                }}
                selectedKeys={[pathKey]}
                mode="inline"
                items={filteredItems}
                //onClick={({ key }) => navigate(key)}
                theme='light'
                openKeys={openKeys}
                onOpenChange={onOpenChange}
            // style={{ fontWeight: 'bold', background: "#ffffff", color: "#000000" }}

            />
        </div>
    );
}
